<template>
  <footer class="app-footer">
    <div class="footer-inner">
      <a href="https://esz-becker.de/impressum/" target="_blank" rel="noopener noreferrer">Impressum</a>
      <span class="divider">|</span>
      <a href="https://esz-becker.de/datenschutz/" target="_blank" rel="noopener noreferrer">Datenschutz</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped lang="scss">
.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #1e1e1e;
  padding: 0.5rem 1rem;

.footer-inner {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  align-items: center;
}

.divider {
  opacity: 0.6;
}
}
</style>
